export const resolve = (path, obj) => {
  const pathParts = path.split('.');
  return pathParts.reduce((o, i) => {
    try {
      if (!o) {
        return undefined;
      }
      if (i.includes('[')) {
        const arr = o[i.split('[')[0]];
        return arr[i.split('[')[1].replace(']', '')];
      } else {
        return o[i];
      }
    } catch {
      return undefined;
    }
  }, obj);
};
